import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { type ButtonProps, Button as PaperButton } from "react-native-paper";
import type { IconType } from "../types";
type Props = ButtonProps & {
	icon?: IconType;
};

const Button = (props: Props) => {
	const { icon, ...rest } = props;
	return (
		<PaperButton
			icon={(props) => <Icon name={icon as IconType} {...props} />}
			{...rest}
		/>
	);
};

export default Button;
